import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryUsername from "components/Run/elements/HistoryEntryUsername";
import HistoryEntryLabel from "components/Run/elements/HistoryEntryLabel";

import { RunHistoryEntryType } from "../../types";

type CanceledEntryProps = {
  timestamp: number;
  username: string | null;
};

// TODO: no designs
const CanceledEntry = ({ timestamp, username }: CanceledEntryProps) => {
  const label = (
    <HistoryEntryLabel>
      <strong>Canceled</strong> <HistoryEntryUsername username={username} />
    </HistoryEntryLabel>
  );

  return (
    <HistoryEntryWrapper
      label={label}
      state={RunHistoryEntryType.Canceled}
      timestamp={timestamp}
      terminal
    />
  );
};

export default CanceledEntry;
